(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["age-verification-modal"]) return;
  try {
    
  class AgeVerificationModal extends HTMLElement {
    static STORAGE_KEY = 'toasted:age-verified-until';

    connectedCallback() {
      this.confirmButton = this.querySelector('[data-age-verification-confirm]');
      this.declineButton = this.querySelector('[data-age-verification-decline]');
      this.errorMessage = this.querySelector('[data-age-verification-error]');
      this.rememberDays = Number(this.dataset.rememberDays) || 60;

      if (this.hasAttribute('open')) {
        document.body.style.overflow = 'hidden';
        this.confirmButton?.focus({ preventScroll: true });
      }

      this.confirmButton?.addEventListener('click', () => this.confirm());
      this.declineButton?.addEventListener('click', () => this.decline());
    }

    confirm() {
      try {
        const until = Date.now() + this.rememberDays * 24 * 60 * 60 * 1000;
        localStorage.setItem(AgeVerificationModal.STORAGE_KEY, String(until));
      } catch (error) {
        // localStorage unavailable (private browsing, disabled storage, etc.) - modal will reopen next visit.
      }

      this.close();
    }

    decline() {
      this.errorMessage?.classList.remove('hidden');
    }

    close() {
      this.removeAttribute('open');
      document.body.style.overflow = '';
    }
  }

  customElements.define('age-verification-modal', AgeVerificationModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarCarousel extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-announcement-bar-item]'));
      this.activeIndex = 0;
      this.interval = parseInt(this.dataset.autoplayInterval, 10) || 3000;
      this.timer = null;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.items.length === 0) return;

      this.items.forEach((item, index) => {
        const isActive = index === 0;
        item.classList.toggle('is-active', isActive);
        item.inert = !isActive;
      });

      if (this.items.length <= 1) return;

      this.handlePause = () => this.stop();
      this.handleFocusOut = (event) => {
        if (!this.contains(event.relatedTarget)) this.start();
      };
      this.handleBlockSelect = (event) => {
        const item = event.target.closest('[data-announcement-bar-item]');
        if (!item || !this.contains(item)) return;
        this.stop();
        this.goTo(this.items.indexOf(item));
      };
      this.handleBlockDeselect = () => this.start();

      this.addEventListener('focusin', this.handlePause);
      this.addEventListener('focusout', this.handleFocusOut);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
    }

    start() {
      if (this.prefersReducedMotion || this.items.length <= 1) return;
      this.stop();
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    next() {
      this.goTo((this.activeIndex + 1) % this.items.length);
    }

    goTo(index) {
      const current = this.items[this.activeIndex];
      const next = this.items[index];
      if (!current || !next || current === next) return;

      current.classList.remove('is-active');
      current.inert = true;
      next.classList.add('is-active');
      next.inert = false;
      this.activeIndex = index;
    }
  }

  customElements.define('announcement-bar-carousel', AnnouncementBarCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
  class BundleBuilder extends HTMLElement {
    connectedCallback() {
      this.items = new Map();
      this.itemIdCounter = 0;

      this.track = this.querySelector('[data-bundle-track]');
      this.milestones = Array.from(this.querySelectorAll('[data-bundle-milestone]'));
      this.progressFill = this.querySelector('[data-bundle-progress-fill]');
      this.addToCartButton = this.querySelector('[data-bundle-add-to-cart]');
      this.addToCartLabel = this.querySelector('[data-bundle-add-to-cart-label]');
      this.addToCartLoader = this.querySelector('[data-bundle-add-to-cart-loader]');
      this.priceOneTime = this.querySelector('[data-bundle-price-one-time]');
      this.priceSubscribe = this.querySelector('[data-bundle-price-subscribe]');
      this.priceOneTimeOriginal = this.querySelector('[data-bundle-price-one-time-original]');
      this.priceSubscribeOriginal = this.querySelector('[data-bundle-price-subscribe-original]');
      this.removeIconMarkup = this.querySelector('[data-bundle-remove-icon]')?.innerHTML || '&times;';
      this.removeLabelTemplate = this.dataset.removeLabelTemplate || 'Remove __TITLE__';
      this.placeholderCount = Number(this.dataset.placeholderCount || 6);
      this.discounts = JSON.parse(this.dataset.discounts || '[]');

      this.drawerToggle = this.querySelector('[data-bundle-drawer-toggle]');
      this.drawerExpandLabel = this.dataset.drawerExpandLabel || 'Expand your bundle';
      this.drawerCollapseLabel = this.dataset.drawerCollapseLabel || 'Collapse your bundle';
      this.setDrawerOpen(false);

      this.addEventListener('click', (event) => {
        const addButton = event.target.closest('[data-bundle-add]');
        if (addButton) {
          if (this.items.size < this.placeholderCount) {
            this.addItem(addButton.dataset);
          }
          return;
        }

        const removeButton = event.target.closest('[data-bundle-remove]');
        if (removeButton) {
          this.removeItem(Number(removeButton.dataset.itemId));
          return;
        }

        if (event.target.closest('[data-bundle-drawer-toggle]')) {
          this.setDrawerOpen(!this.hasAttribute('open'));
          return;
        }

        if (event.target.closest('[data-bundle-drawer-close]')) this.setDrawerOpen(false);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.hasAttribute('open')) this.setDrawerOpen(false);
      });

      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-bundle-purchase-type]')) this.render();
      });

      this.form = this.querySelector('[data-bundle-form]');
      this.form?.addEventListener('submit', (event) => this.handleSubmit(event));

      this.render();
    }

    setDrawerOpen(isOpen) {
      this.toggleAttribute('open', isOpen);
      if (this.drawerToggle) {
        this.drawerToggle.setAttribute('aria-expanded', String(isOpen));
        this.drawerToggle.setAttribute('aria-label', isOpen ? this.drawerCollapseLabel : this.drawerExpandLabel);
      }
    }

    addItem(dataset) {
      const itemId = ++this.itemIdCounter;
      this.items.set(itemId, {
        itemId,
        blockId: dataset.blockId,
        variantId: dataset.variantId,
        title: dataset.title,
        image: dataset.image,
        price: Number(dataset.price || 0),
        sellingPlanId: dataset.sellingPlanId || null,
        subscribePrice: dataset.subscribePrice ? Number(dataset.subscribePrice) : null,
      });

      this.render();
    }

    removeItem(itemId) {
      this.items.delete(itemId);
      this.render();
    }

    get isSubscribing() {
      return this.querySelector('[data-bundle-purchase-type]:checked')?.value === 'subscribe';
    }

    get subtotalCents() {
      let total = 0;
      for (const item of this.items.values()) {
        const unit = this.isSubscribing && item.subscribePrice ? item.subscribePrice : item.price;
        total += unit;
      }
      return total;
    }

    get totalQuantity() {
      return this.items.size;
    }

    render() {
      this.renderTrack();
      this.renderMilestones();
      this.renderPrices();
      if (this.addToCartButton) this.addToCartButton.disabled = this.totalQuantity === 0;
    }

    renderPrices() {
      let oneTimeSubtotal = 0;
      for (const item of this.items.values()) {
        oneTimeSubtotal += item.price;
      }
      let subscribeSubtotal = 0;
      for (const item of this.items.values()) {
        const price = item.subscribePrice || item.price;
        subscribeSubtotal += price;
      }

      const oneTimeDiscount = this.getAppliedDiscount(oneTimeSubtotal);
      const subscribeDiscount = this.getAppliedDiscount(subscribeSubtotal);

      const oneTimeDiscounted = Math.max(0, oneTimeSubtotal - oneTimeDiscount);
      const subscribeDiscounted = Math.max(0, subscribeSubtotal - subscribeDiscount);

      if (this.priceOneTimeOriginal) {
        this.priceOneTimeOriginal.textContent = this.formatPrice(oneTimeSubtotal);
      }
      if (this.priceOneTime) {
        this.priceOneTime.textContent = this.formatPrice(oneTimeDiscounted);
      }

      if (this.priceSubscribeOriginal) {
        this.priceSubscribeOriginal.textContent = this.formatPrice(subscribeSubtotal);
      }
      if (this.priceSubscribe) {
        this.priceSubscribe.textContent = this.formatPrice(subscribeDiscounted);
      }
    }

    getAppliedDiscount(subtotal) {
      let applicableDiscount = 0;
      for (const discount of this.discounts) {
        if (subtotal >= discount.threshold) {
          applicableDiscount = discount.discount;
        }
      }
      return applicableDiscount;
    }

    getOneTimeTotal() {
      let subtotal = 0;
      for (const item of this.items.values()) {
        subtotal += item.price;
      }
      const discount = this.getAppliedDiscount(subtotal);
      return Math.max(0, subtotal - discount);
    }

    getSubscribeTotal() {
      let subtotal = 0;
      for (const item of this.items.values()) {
        const price = item.subscribePrice || item.price;
        subtotal += price;
      }
      const discount = this.getAppliedDiscount(subtotal);
      return Math.max(0, subtotal - discount);
    }

    formatPrice(cents) {
      return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    renderTrack() {
      if (!this.track) return;
      this.track.innerHTML = '';

      for (const item of this.items.values()) {
        const card = document.createElement('div');
        card.className =
          'relative h-[130px] w-[100px] shrink-0 overflow-hidden rounded-xl border border-[#212323]/10 bg-white';

        const img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title;
        img.className = 'size-full object-cover';
        card.appendChild(img);

        const removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.className =
          'absolute right-1.5 top-1.5 flex size-6 items-center justify-center rounded-full bg-[#212323] text-[#F6F1EC] [&_svg]:size-3';
        removeButton.dataset.bundleRemove = '';
        removeButton.dataset.itemId = item.itemId;
        removeButton.setAttribute('aria-label', this.removeLabelTemplate.replace('__TITLE__', item.title));
        removeButton.innerHTML = this.removeIconMarkup;
        card.appendChild(removeButton);

        this.track.appendChild(card);
      }

      const placeholdersNeeded = Math.max(0, this.placeholderCount - this.items.size);
      for (let i = 0; i < placeholdersNeeded; i += 1) {
        const placeholder = document.createElement('div');
        placeholder.className = 'h-[130px] w-[100px] shrink-0 rounded-xl border border-dashed border-black/50';
        this.track.appendChild(placeholder);
      }
    }

    renderMilestones() {
      const subtotal = this.subtotalCents;

      if (this.progressFill) {
        this.progressFill.style.width = `${this.getProgressPercent(subtotal)}%`;
      }

      this.milestones.forEach((el) => {
        const pill = el.querySelector('[data-bundle-milestone-pill]');
        if (!pill) return;

        const achieved = Number(el.dataset.threshold) <= subtotal;

        pill.classList.toggle('bg-[#212323]', achieved);
        pill.classList.toggle('text-[#F6F1EC]', achieved);
        pill.classList.toggle('bg-white', !achieved);
        pill.classList.toggle('text-[#212323]', !achieved);
      });
    }

    getProgressPercent(subtotal) {
      const thresholds = this.milestones
        .map((el) => Number(el.dataset.threshold))
        .sort((a, b) => a - b);

      const count = thresholds.length;
      if (count === 0) return 0;
      if (subtotal <= 0) return 0;

      const positions = thresholds.map((_, index) => ((index + 0.75) / count) * 100);

      if (subtotal >= thresholds[count - 1]) return 100;

      let lowerIndex = -1;
      for (let i = 0; i < count; i += 1) {
        if (subtotal >= thresholds[i]) lowerIndex = i;
      }

      const lowerThreshold = lowerIndex >= 0 ? thresholds[lowerIndex] : 0;
      const lowerPosition = lowerIndex >= 0 ? positions[lowerIndex] : 0;
      const upperThreshold = thresholds[lowerIndex + 1];
      const upperPosition = positions[lowerIndex + 1];

      const ratio = (subtotal - lowerThreshold) / (upperThreshold - lowerThreshold);
      return lowerPosition + ratio * (upperPosition - lowerPosition);
    }

    async handleSubmit(event) {
      event.preventDefault();
      if (this.totalQuantity === 0) return;

      const subscribing = this.isSubscribing;
      const items = Array.from(this.items.values()).map((item) => {
        const payload = { id: item.variantId, quantity: 1 };
        if (subscribing && item.sellingPlanId) payload.selling_plan = item.sellingPlanId;
        return payload;
      });

      this.addToCartButton.disabled = true;
      this.addToCartLabel?.classList.add('invisible');
      this.addToCartLoader?.classList.remove('hidden');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });

        if (!response.ok) throw new Error('Failed to add bundle to cart');

        this.items.clear();
        this.render();
        this.setDrawerOpen(false);

        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          await drawer.refresh();
          drawer.open();
        }
      } catch (error) {
        this.addToCartButton.disabled = this.totalQuantity === 0;
      } finally {
        this.addToCartLabel?.classList.remove('invisible');
        this.addToCartLoader?.classList.add('hidden');
      }
    }
  }

  customElements.define('bundle-builder', BundleBuilder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('quantity-stepper')) {
    class QuantityStepper extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-quantity-input]');
        this.decreaseButton = this.querySelector('[data-quantity-decrease]');
        this.increaseButton = this.querySelector('[data-quantity-increase]');

        this.decreaseButton?.addEventListener('click', () => this.step(-1));
        this.increaseButton?.addEventListener('click', () => this.step(1));
        this.input?.addEventListener('change', () => this.setValue(this.input.valueAsNumber));
      }

      get min() {
        return Number(this.input?.min || 0);
      }

      step(delta) {
        const current = this.input?.valueAsNumber || 0;
        this.setValue(current + delta);
      }

      setValue(value) {
        const min = this.min;
        const next = Number.isFinite(value) ? Math.max(min, Math.round(value)) : min;

        if (this.input) this.input.value = next;
        if (this.decreaseButton) this.decreaseButton.disabled = next <= min;

        this.dispatchEvent(new CustomEvent('quantity-change', { bubbles: true, detail: { value: next } }));
      }
    }

    customElements.define('quantity-stepper', QuantityStepper);
  }

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-cart-drawer-content]');
      this.lastTrigger = null;

      document.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-cart-drawer-open]');
        if (opener) {
          event.preventDefault();
          this.lastTrigger = opener;
          this.open();
          return;
        }

        if (event.target.closest('[data-cart-drawer-close]')) {
          this.close();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.hasAttribute('open')) this.close();
      });

      this.addEventListener('click', (event) => {
        const removeLink = event.target.closest('[data-cart-remove]');
        if (removeLink) {
          event.preventDefault();
          const line = removeLink.closest('[data-line]')?.dataset.line;
          if (line) this.changeLine(line, 0);
        }

        const addButton = event.target.closest('[data-cart-add]');
        if (addButton) {
          event.preventDefault();
          this.addItem({ id: addButton.dataset.variantId, quantity: 1 });
        }
      });

      this.addEventListener('quantity-change', (event) => {
        const line = event.target.closest('[data-line]')?.dataset.line;
        if (line) this.changeLine(line, event.detail.value);
      });
    }

    open() {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      this.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
      if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;
      this.querySelector('[data-cart-drawer-close]:not([aria-hidden])')?.focus({ preventScroll: true });
    }

    close() {
      this.removeAttribute('open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      this.lastTrigger?.focus({ preventScroll: true });
    }

    async addItem(data) {
      const isFormData = data instanceof FormData;

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: isFormData
          ? { Accept: 'application/json' }
          : { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: isFormData ? data : JSON.stringify(data),
      });

      if (!response.ok) throw new Error('Failed to add item to cart');

      await this.refresh();
      this.open();
    }

    async changeLine(line, quantity) {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
      });

      if (!response.ok) throw new Error('Failed to update cart');

      await this.refresh();
    }

    async refresh() {
      const response = await fetch(`${window.location.pathname}?sections=cart-drawer`);
      if (!response.ok) return;

      const data = await response.json();
      const html = data['cart-drawer'];
      if (!html) return;

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const nextContent = parsed.querySelector('[data-cart-drawer-content]');
      if (nextContent && this.content) this.content.innerHTML = nextContent.innerHTML;

      document.dispatchEvent(new CustomEvent('cart:updated'));
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  class CartRecommendations extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-recommendations-track]');
      this.querySelector('[data-recommendations-prev]')?.addEventListener('click', () => this.scroll(-1));
      this.querySelector('[data-recommendations-next]')?.addEventListener('click', () => this.scroll(1));
    }

    scroll(direction) {
      const amount = this.track.clientWidth * 0.8 * direction;
      this.track?.scrollBy({ left: amount, behavior: 'smooth' });
    }
  }

  customElements.define('cart-recommendations', CartRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coa-cards"] && !Shopify.designMode) return;
  try {
    
  class CoaFilter extends HTMLElement {
    connectedCallback() {
      this.titleInput = this.querySelector('[data-filter-title]');
      this.batchInput = this.querySelector('[data-filter-batch]');
      this.rows = Array.from(this.querySelectorAll('[data-coa-row]'));
      this.emptyState = this.querySelector('[data-coa-empty]');

      [this.titleInput, this.batchInput].forEach((input) => {
        input?.addEventListener('input', () => this.filter());
      });
    }

    filter() {
      const titleQuery = (this.titleInput?.value || '').trim().toLowerCase();
      const batchQuery = (this.batchInput?.value || '').trim().toLowerCase();

      let visibleCount = 0;

      this.rows.forEach((row) => {
        const matchesTitle = !titleQuery || row.dataset.title.toLowerCase().includes(titleQuery);
        const matchesBatch = !batchQuery || row.dataset.batch.toLowerCase().includes(batchQuery);
        const isVisible = matchesTitle && matchesBatch;

        row.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (this.emptyState) this.emptyState.hidden = visibleCount > 0;
    }
  }

  customElements.define('coa-filter', CoaFilter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const forms = document.querySelectorAll('.contact-form');

    forms.forEach(form => {
      form.addEventListener('submit', async function(e) {
        e.preventDefault();

        const formData = new FormData(form);
        const endpoint = form.getAttribute('data-form-handler');
        const successMessage = form.getAttribute('data-success-message');
        const errorMessage = form.getAttribute('data-error-message');

        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            body: formData,
            headers: {
              'Accept': 'application/json'
            }
          });

          if (response.ok) {
            form.reset();
            alert(successMessage);
          } else {
            alert(errorMessage);
          }
        } catch (error) {
          console.error('Form submission error:', error);
          alert(errorMessage);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-promo-row"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const setContactPromoStickyOffsets = () => {
      document.querySelectorAll('.contact-promo-row').forEach((section) => {
        const promoCards = section.querySelector('.contact-promo-row__promo-cards');
        if (!promoCards) return;

        if (!window.matchMedia('(min-width: 1024px)').matches) {
          promoCards.style.removeProperty('--contact-promo-cards-sticky-top');
          return;
        }

        const topPadding = 80;
        const bottomOffset = 0;
        const stickyTop = Math.min(topPadding, window.innerHeight - promoCards.offsetHeight - bottomOffset);
        promoCards.style.setProperty('--contact-promo-cards-sticky-top', `${stickyTop}px`);
      });
    };

    setContactPromoStickyOffsets();
    window.addEventListener('resize', setContactPromoStickyOffsets);
    document.addEventListener('shopify:section:load', setContactPromoStickyOffsets);

    const forms = document.querySelectorAll('.contact-form');

    forms.forEach(form => {
      form.addEventListener('submit', async function(e) {
        e.preventDefault();

        const formData = new FormData(form);
        const endpoint = form.getAttribute('data-form-handler');
        const successMessage = form.getAttribute('data-success-message');
        const errorMessage = form.getAttribute('data-error-message');

        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            body: formData,
            headers: {
              'Accept': 'application/json'
            }
          });

          if (response.ok) {
            form.reset();
            alert(successMessage);
          } else {
            alert(errorMessage);
          }
        } catch (error) {
          console.error('Form submission error:', error);
          alert(errorMessage);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq-item-toggle').forEach(button => {
    button.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      const answerId = this.getAttribute('aria-controls');
      const answerElement = document.getElementById(answerId);

      this.setAttribute('aria-expanded', !isExpanded);
      answerElement.classList.toggle('show', !isExpanded);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const mobileStickyQuery = window.matchMedia('(max-width: 47.9375rem)');
  let lastScrollY = window.scrollY;
  let stickyTicking = false;

  const updateMobileStickyNavbar = () => {
    const currentScrollY = window.scrollY;

    document.querySelectorAll('[data-navbar]').forEach((navbar) => {
      if (!mobileStickyQuery.matches) {
        navbar.classList.remove('navbar--mobile-fixed');
        navbar.classList.remove('navbar--sticky-hidden');
        return;
      }

      const navbarBar = navbar.querySelector('.navbar__bar');
      const navbarBarHeight = navbarBar ? navbarBar.offsetHeight : 0;
      if (navbarBarHeight) {
        navbar.style.setProperty('--navbar-bar-height', `${navbarBarHeight}px`);
      }

      const navbarStart = navbar.offsetTop;
      const isFixed = currentScrollY >= navbarStart;

      navbar.classList.toggle('navbar--mobile-fixed', isFixed);

      if (!isFixed || navbar.classList.contains('navbar--menu-open') || currentScrollY <= 80) {
        navbar.classList.remove('navbar--sticky-hidden');
        return;
      }

      if (currentScrollY > lastScrollY + 8) {
        navbar.classList.add('navbar--sticky-hidden');
      }

      if (currentScrollY < lastScrollY - 8) {
        navbar.classList.remove('navbar--sticky-hidden');
      }
    });

    lastScrollY = currentScrollY;
    stickyTicking = false;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (stickyTicking) return;

      stickyTicking = true;
      window.requestAnimationFrame(updateMobileStickyNavbar);
    },
    { passive: true }
  );

  mobileStickyQuery.addEventListener('change', updateMobileStickyNavbar);
  updateMobileStickyNavbar();

  document.addEventListener('click', function (event) {
    const navbar = event.target.closest('[data-navbar]');
    const toggle = event.target.closest('[data-navbar-toggle]');

    const setToggleState = (currentNavbar, isOpen) => {
      currentNavbar.querySelectorAll('[data-navbar-toggle]').forEach((navbarToggle) => {
        navbarToggle.setAttribute('aria-expanded', String(isOpen));
      });
    };

    if (toggle) {
      const currentNavbar = toggle.closest('[data-navbar]');
      const isOpen = currentNavbar.classList.contains('navbar--menu-open');

      currentNavbar.classList.toggle('navbar--menu-open', !isOpen);
      setToggleState(currentNavbar, !isOpen);
      currentNavbar.classList.remove('navbar--sticky-hidden');
      return;
    }

    document.querySelectorAll('[data-navbar].navbar--menu-open').forEach((openNavbar) => {
      if (openNavbar !== navbar || !event.target.closest('[data-navbar-dropdown]')) {
        openNavbar.classList.remove('navbar--menu-open');
        setToggleState(openNavbar, false);
      }
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-navbar].navbar--menu-open').forEach((openNavbar) => {
      openNavbar.classList.remove('navbar--menu-open');
      openNavbar.querySelectorAll('[data-navbar-toggle]').forEach((navbarToggle) => {
        navbarToggle.setAttribute('aria-expanded', 'false');
      });
    });
  });

  // Cart update listener
  document.addEventListener('cart:updated', async () => {
    const response = await fetch('/cart.js');
    if (!response.ok) return;

    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      this.activeIndex = 0;
      this.interval = parseInt(this.dataset.autoplayInterval, 10) || 5000;
      this.timer = null;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.slides.length === 0) return;

      this.slides.forEach((slide, index) => {
        const isActive = index === 0;
        slide.classList.toggle('is-active', isActive);
        slide.inert = !isActive;
      });

      if (this.slides.length <= 1) return;

      this.handlePause = () => this.stop();
      this.handleFocusOut = (event) => {
        if (!this.contains(event.relatedTarget)) this.start();
      };
      this.handleBlockSelect = (event) => {
        const slide = event.target.closest('[data-hero-slide]');
        if (!slide || !this.contains(slide)) return;
        this.stop();
        this.goTo(this.slides.indexOf(slide));
      };
      this.handleBlockDeselect = () => this.start();

      this.addEventListener('focusin', this.handlePause);
      this.addEventListener('focusout', this.handleFocusOut);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
    }

    start() {
      if (this.prefersReducedMotion || this.slides.length <= 1) return;
      this.stop();
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    next() {
      this.goTo((this.activeIndex + 1) % this.slides.length);
    }

    goTo(index) {
      const current = this.slides[this.activeIndex];
      const next = this.slides[index];
      if (!current || !next || current === next) return;

      current.classList.remove('is-active');
      current.inert = true;
      next.classList.add('is-active');
      next.inert = false;
      this.activeIndex = index;
    }
  }

  customElements.define('hero-carousel', HeroCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  class ProductPurchase extends HTMLElement {
    connectedCallback() {
      const dataScript = document.querySelector('[data-product-purchase-data]');
      this.data = dataScript ? JSON.parse(dataScript.textContent) : { variants: {} };

      this.buyButton = this.querySelector('[data-buy-button]');
      this.buyButtonLabel = this.querySelector('[data-buy-button-label]');
      this.buyButtonPrice = this.querySelector('[data-buy-button-price]');
      this.subscribePrice = this.querySelector('[data-subscribe-price]');
      this.subscribeSavings = this.querySelector('[data-subscribe-savings]');
      this.subscribePercentPill = this.querySelector('[data-subscribe-percent-pill]');
      this.oneTimePrice = this.querySelector('[data-one-time-price]');
      this.form = this.querySelector('form');

      this.addEventListener('change', (event) => {
        if (event.target.matches('[name="id"], [name="selling_plan"]')) this.update();
      });

      this.form?.addEventListener('submit', (event) => this.handleSubmit(event));
    }

    async handleSubmit(event) {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      event.preventDefault();

      const buttonContent = this.buyButton.querySelector('[data-buy-button-content]');
      const buttonLoader = this.buyButton.querySelector('[data-buy-button-loader]');

      try {
        this.buyButton.disabled = true;
        buttonContent.classList.add('hidden');
        buttonLoader.classList.remove('hidden');

        await drawer.addItem(new FormData(this.form));
      } catch (error) {
        this.form.submit();
      } finally {
        this.buyButton.disabled = false;
        buttonContent.classList.remove('hidden');
        buttonLoader.classList.add('hidden');
      }
    }

    get currentVariant() {
      const id = this.querySelector('[name="id"]:checked')?.value;
      return id ? this.data.variants[id] : null;
    }

    get isSubscribing() {
      return Boolean(this.querySelector('[name="selling_plan"]:checked')?.value);
    }

    update() {
      const variant = this.currentVariant;
      if (!variant) return;

      if (this.oneTimePrice) this.oneTimePrice.textContent = variant.priceHtml;

      if (variant.hasSubscription) {
        if (this.subscribePrice) this.subscribePrice.textContent = variant.subscribePriceHtml;
        if (this.subscribeSavings) this.subscribeSavings.textContent = variant.subscribeSavingsHtml;
        if (this.subscribePercentPill) {
          const pillText = this.subscribePercentPill.textContent;
          const newText = pillText.replace(/\d+%/, `${variant.subscribePercent}%`);
          this.subscribePercentPill.textContent = newText;
        }
      }

      const subscribing = variant.hasSubscription && this.isSubscribing;

      if (this.buyButtonPrice) {
        const hasCustomLabel = this.buyButtonLabel?.dataset.hasCustomLabel === 'true';
        this.buyButtonPrice.hidden = true;
      }

      if (this.buyButtonLabel) {
        const hasCustomLabel = this.buyButtonLabel.dataset.hasCustomLabel === 'true';
        if (!hasCustomLabel) {
          if (!variant.available) {
            this.buyButtonLabel.textContent = this.buyButtonLabel.dataset.soldOutLabel;
          } else {
            const label = subscribing
              ? this.buyButtonLabel.dataset.subscribeLabel
              : this.buyButtonLabel.dataset.oneTimeLabel;
            const price = subscribing ? variant.subscribePriceHtml : variant.priceHtml;
            this.buyButtonLabel.innerHTML = `${label} ${price}`;
          }
        }
      }

      if (this.buyButton) this.buyButton.disabled = !variant.available;
    }
  }

  customElements.define('product-purchase', ProductPurchase);

  class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.buyButton = document.querySelector('[data-buy-button]');
      if (!this.buyButton || typeof IntersectionObserver === 'undefined') return;

      this.observer = new IntersectionObserver(([entry]) => {
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('is-visible', scrolledPast);
      });

      this.observer.observe(this.buyButton);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-modal"]) return;
  try {
    
  class SearchModal extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-search-panel]');
      this.form = this.querySelector('[data-search-form]');
      this.input = this.querySelector('[data-search-input]');
      this.clearButton = this.querySelector('[data-search-clear]');
      this.resultsContainer = this.querySelector('[data-search-results]');
      this.lastTrigger = null;
      this.abortController = null;

      this.form?.addEventListener('submit', (event) => {
        event.preventDefault();
      });

      document.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-search-open]');
        if (opener) {
          event.preventDefault();
          this.lastTrigger = opener;
          this.open();
          return;
        }

        if (event.target.closest('[data-search-close]')) {
          this.close();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.hasAttribute('open')) this.close();
      });

      this.input.addEventListener('input', this.debounce(() => this.onQueryChange(), 300));

      this.clearButton?.addEventListener('click', () => {
        this.input.value = '';
        this.input.focus();
        this.onQueryChange();
      });

      this.onResize = () => this.positionPanel();
    }

    positionPanel() {
      const navbar = document.querySelector('.navbar');
      if (!navbar) return;
      const rect = navbar.getBoundingClientRect();
      this.panel.style.top = `${rect.bottom + window.scrollY}px`;
    }

    debounce(callback, wait) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => callback(...args), wait);
      };
    }

    open() {
      this.positionPanel();
      this.setAttribute('open', '');
      this.input.focus({ preventScroll: true });
      window.addEventListener('resize', this.onResize);
    }

    close() {
      this.removeAttribute('open');
      this.abortController?.abort();
      this.input.value = '';
      this.hideResults();
      this.clearButton?.classList.add('hidden');
      this.lastTrigger?.focus({ preventScroll: true });
      window.removeEventListener('resize', this.onResize);
    }

    hideResults() {
      this.resultsContainer.innerHTML = '';
      this.resultsContainer.classList.add('hidden');
      this.resultsContainer.classList.remove('flex');
    }

    showResults(html) {
      this.resultsContainer.innerHTML = html;
      this.resultsContainer.classList.remove('hidden');
      this.resultsContainer.classList.add('flex');
    }

    onQueryChange() {
      const term = this.input.value.trim();
      this.clearButton?.classList.toggle('hidden', term.length === 0);

      this.abortController?.abort();

      if (!term.length) {
        this.hideResults();
        return;
      }

      this.abortController = new AbortController();
      this.showResults(
        `<p class="px-6 pb-6 text-center text-[14px] text-[#212323]/70 sm:px-9">${this.dataset.loadingText || ''}</p>`
      );

      const url = `${this.dataset.predictiveSearchUrl}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&section_id=search-modal`;

      fetch(url, { signal: this.abortController.signal })
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((text) => {
          const parsed = new DOMParser().parseFromString(text, 'text/html');
          const next = parsed.getElementById('search-modal-results');
          const html = next ? next.innerHTML : '';
          if (html.trim()) {
            this.showResults(html);
          } else {
            this.hideResults();
          }
        })
        .catch((error) => {
          if (error.name === 'AbortError') return;
          this.hideResults();
        });
    }
  }

  customElements.define('search-modal', SearchModal);

  } catch(e) { console.error(e); }
})();
})();
